import { useState } from 'react';
import { affiliateApi } from '../api/affiliate';
import { toast } from 'react-hot-toast';

export function useAffiliate() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const applyForAffiliate = async (data: Parameters<typeof affiliateApi.applyForAffiliate>[0]) => {
    setLoading(true);
    setError(null);
    try {
      const affiliate = await affiliateApi.applyForAffiliate(data);
      toast.success('Demande d\'affiliation envoyée avec succès');
      return affiliate;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Erreur lors de la demande d\'affiliation';
      setError(message);
      toast.error(message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const createAffiliateLink = async (toolId: string) => {
    setLoading(true);
    setError(null);
    try {
      const link = await affiliateApi.createAffiliateLink(toolId);
      toast.success('Lien d\'affiliation créé avec succès');
      return link;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Erreur lors de la création du lien';
      setError(message);
      toast.error(message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    applyForAffiliate,
    createAffiliateLink,
    getAffiliateStatus: affiliateApi.getAffiliateStatus,
    getAffiliateLinks: affiliateApi.getAffiliateLinks,
    getClickStats: affiliateApi.getClickStats,
    getConversionStats: affiliateApi.getConversionStats,
    trackClick: affiliateApi.trackClick
  };
}